import { getStorageItem } from '../../utils/cache'
export default {
  methods: {
    getDisabled () {
      let disabled = false
      const auth = getStorageItem('auth')
      if (auth && auth.role && auth.role.indexOf('patient') >= 0 &&
          this.role && this.role.indexOf('patient') >= 0) {
        disabled = false
      }
      return disabled
    }
  }
}
